"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pick = exports.omit = void 0;

/**
 * Filter an object, (white/black)listing the allowed keys
 *
 * @param {*} rawObject Object to filter
 * @param {*} keysToFilter Set of keys to filter
 * @param {*} shouldWhitelist True to whitelist (keep only the given props), false to blacklist (remove the given props)
 */
var filterObject = function filterObject(rawObject, keysToFilter, shouldWhitelist) {
  return Object.keys(rawObject).filter(function (key) {
    return keysToFilter.includes(key) === shouldWhitelist;
  }).reduce(function (out, key) {
    out[key] = rawObject[key];
    return out;
  }, {});
};
/**
 * Blacklist the given keys from the object
 * Note that this method does not have feature parity with Lodash's omit (e.g. paths)
 *
 * @param {*} rawObject Object to filter
 * @param {*} keysToRemove Keys to remove from the object
 */

var omit = function omit(rawObject, keysToRemove) {
  return filterObject(rawObject || {}, keysToRemove || [], false);
};
/**
 * Whitelist the given keys from the object
 * Note that this method does not have feature parity with Lodash's pick (e.g. paths)
 *
 * @param {*} rawObject Object to filter
 * @param {*} keysToRemove Keys to keep from the object
 */

exports.omit = omit;
var pick = function pick(rawObject, keysToKeep) {
  return filterObject(rawObject || {}, keysToKeep || [], true);
};
exports.pick = pick;